module.exports = __webpack_public_path__ + "why5.webp?c67625d06f1b75caa7e2d541a26fb349";